import {
  FETCH_WORKFLOW_CONFIG,
  FETCH_WORKFLOW_CONFIG_SUCCESS,
  FETCH_WORKFLOW_CONFIG_FAIL,
  SAVE_WORKFLOW_CONFIG,
  SAVE_WORKFLOW_CONFIG_SUCCESS,
  SAVE_WORKFLOW_CONFIG_FAIL,
  FETCH_ORDER_TRANSITIONS,
  FETCH_ORDER_TRANSITIONS_SUCCESS,
  FETCH_ORDER_TRANSITIONS_FAIL,
  EXECUTE_ORDER_TRANSITION,
  EXECUTE_ORDER_TRANSITION_SUCCESS,
  EXECUTE_ORDER_TRANSITION_FAIL,
  CLEAR_WORKFLOW_ERROR,
} from "./actionTypes"

const INIT_STATE = {
  config: null,
  configLoading: false,
  configSaving: false,
  transitions: [],
  transitionsLoading: false,
  executing: false,
  error: null,
}

const workflow = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Fetch Config
    case FETCH_WORKFLOW_CONFIG:
      return {
        ...state,
        configLoading: true,
        error: null,
      }

    case FETCH_WORKFLOW_CONFIG_SUCCESS:
      return {
        ...state,
        config: action.payload,
        configLoading: false,
      }

    case FETCH_WORKFLOW_CONFIG_FAIL:
      return {
        ...state,
        configLoading: false,
        error: action.payload,
      }

    // Save Config
    case SAVE_WORKFLOW_CONFIG:
      return {
        ...state,
        configSaving: true,
        error: null,
      }

    case SAVE_WORKFLOW_CONFIG_SUCCESS:
      return {
        ...state,
        config: action.payload,
        configSaving: false,
      }

    case SAVE_WORKFLOW_CONFIG_FAIL:
      return {
        ...state,
        configSaving: false,
        error: action.payload,
      }

    // Fetch Transitions
    case FETCH_ORDER_TRANSITIONS:
      return {
        ...state,
        transitionsLoading: true,
        error: null,
      }

    case FETCH_ORDER_TRANSITIONS_SUCCESS:
      return {
        ...state,
        transitions: action.payload,
        transitionsLoading: false,
      }

    case FETCH_ORDER_TRANSITIONS_FAIL:
      return {
        ...state,
        transitionsLoading: false,
        error: action.payload,
      }

    // Execute Transition
    case EXECUTE_ORDER_TRANSITION:
      return {
        ...state,
        executing: true,
        error: null,
      }

    case EXECUTE_ORDER_TRANSITION_SUCCESS:
      return {
        ...state,
        executing: false,
      }

    case EXECUTE_ORDER_TRANSITION_FAIL:
      return {
        ...state,
        executing: false,
        error: action.payload,
      }

    case CLEAR_WORKFLOW_ERROR:
      return {
        ...state,
        error: null,
      }

    default:
      return state
  }
}

export default workflow
